import { SHIPPAL_ICON } from "../../assets/icons";
export function AuthLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Navbar with logo */}
      <nav className="w-full bg-white border-b border-gray-200 z-50">
        <div className="container mx-auto flex justify-center items-center py-4">
          <div className="hover:bg-gray-100 duration-200 rounded-md cursor-pointer p-2">
            {SHIPPAL_ICON}
          </div>
        </div>
      </nav>

      {/* Spacer for navbar height */}
      <div className="h-16" />

      {/* Main content */}
      <div className="flex flex-1 items-center justify-center p-6">
        {children}
      </div>
    </div>
  );
}